import script from "./AssignedQuestionnaireCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignedQuestionnaireCard.vue?vue&type=script&setup=true&lang=js"

import "./AssignedQuestionnaireCard.vue?vue&type=style&index=0&id=efb3008a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb3008a"]])

export default __exports__